import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { publicModuleBase } from '@sad5/contracts';

export function PortalRouter({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter
      basename={publicModuleBase('portal', import.meta.env.BASE_URL)}
    >
      {children}
    </BrowserRouter>
  );
}
